/* eslint linebreak-style: ["error", "unix"] */

import useModalWithQueryParams from 'hooks/useModalWithQueryParams';
import { ModalQueryParams } from 'data/app';
import DesktopNavbarMenuButton from 'components/buttons/button-navbar-desktop-menu/desktop-navbar-menu-button';

export default function AboutMenu() {
  const {
    isOpen,
    handleOpen,
    handleClose,
  } = useModalWithQueryParams(ModalQueryParams.ABOUT);

  return (
    <DesktopNavbarMenuButton
      buttonLabel="A ANJB"
      isActive={isOpen}
      handleOpen={handleOpen}
      handleClose={handleClose}
    />
  );
}
